<template>
    <cod-dialog
        ref="dialog"
        :show.sync="showDialog"
        max-width="500px"
    >
        <!-- Header -->
        <template slot="header">
            <div class="item-form-header">
                {{ $t('bank_statements.bank_account') }}{{ bank ? ` (${bank.name})` : '' }}
            </div>
        </template>

        <!-- Content -->
        <div slot="content" class="item-form">
            <v-text-field
                v-model="form.number"
                :label="$t('general.number')"
                :error-messages="form.$errors.number"
                @blur="form.validate('number')"
                @input="delete form.$errors.number"
            />

            <v-text-field
                v-model="form.description"
                :label="$t('general.description')"
                :error-messages="form.$errors.description"
                @blur="form.validate('description')"
                @input="delete form.$errors.description"
            />
        </div>

        <!-- Footer -->
        <template slot="footer">
            <v-btn
                color="primary"
                :disabled="form.$busy"
                :loading="form.$busy"
                class="flex-1"
                @click="save"
            >
                {{ $t('general.save') }}
            </v-btn>
        </template>

    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';
import ApiService from '@/services/ApiService';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        CodDialog,
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => null
        },
        bank: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            showDialog: false,
            form: this.createForm(),
        };
    },

    validations() {
        return {
            form: {
                number: { required },
            }
        }
    },

    watch: {
        show(val) {
            this.showDialog = val;

            if (val) {
                this.form = this.createForm(this.item);
            }
        },

        showDialog(val) {
            this.$emit('update:show', val);
        }
    },

    methods: {
        createForm(item) {
            return new Form(this, 'form', {
                id: item?.id || null,
                bank_id: this.bank?.id || null,
                number: item?.number || null,
                description: item?.description || null,
            });
        },

        async save() {
            if(!this.form.validate()) return;

            const method = this.form.id ? 'patch' : 'post';
            const url = '/admin/bank-statements/bank-accounts' + (this.form.id ? `/${this.form.id}` : '');

            const response = await ApiService[method](url, this.form);
            this.$emit('save', response.data);
            this.$snackbar(this.$t('bank_statements.bank_account_saved'), 'success');

            this.form = this.createForm();
            this.showDialog = false;
        },
    }
};
</script>

<style lang="scss" scoped>
.item-form {
    padding: 24px;
    min-height: 200px;
}

.item-form-header {
    text-overflow: ellipsis;
    overflow-x: clip;
}
</style>
